import * as React from 'react';
import HudsonLogo from '../../components/hudsonlogos-01.png';
import {
  LogInScreen,
  TopBarLayout,
  MainSectionLayout,
  MiddleBar,
  OuterMiniBoxes,
  MiniBox,
  SmallRectangle,
  WideRectangle,
  BottomSquare,
  RightRectangle,
  InnerMainSectionLayout,
  HudsonLogoStyles,
} from './styles';
 
interface Props {
    children: any;
}
const AuthenticationLayout = (props: Props) => {
  return (
    <>
      <LogInScreen>
        <TopBarLayout />
        <MainSectionLayout>
          <InnerMainSectionLayout>
            <MiddleBar />
            <OuterMiniBoxes>
              <MiniBox />
              <MiniBox />
              <MiniBox />
            </OuterMiniBoxes>
            <SmallRectangle />
            <WideRectangle />
            <BottomSquare />
          </InnerMainSectionLayout>
          <RightRectangle />
        </MainSectionLayout>
      </LogInScreen>
      <div>{props.children}</div>
      <HudsonLogoStyles>
        <img src={HudsonLogo} style={{ width: 180, height: 72 }} />
      </HudsonLogoStyles>
    </>
  );
};

export default AuthenticationLayout;
